import { GraphicCanvas, SvgRootRectangle, SvgRectangleArea, FixedDimension, PercentDimension } from "../../../../web-graphics";
import { Label } from "../svg/label";

export class GraphicCanvasWithFps extends GraphicCanvas {
  constructor(settings) {
    super(settings);

    // add fps meter
    const fpsMeterAreaWidth = 80;
    const fpsMeterAreaHeight = 30;
    const fpsMeterAreaX = this.settings.sizeInPixels.width - 100;
    const fpsMeterAreaY = 2;
    this.fpsMeterAreaRoot = new SvgRootRectangle(
      {
        id: "FpsMeterArea_svgRoot", 
        location: {
          x: new FixedDimension(fpsMeterAreaX),
          y: new FixedDimension(this.settings.htmlObject.sizeInPixels.height - fpsMeterAreaY - fpsMeterAreaHeight)
        },
        size: {
          width: new FixedDimension(fpsMeterAreaWidth),
          height: new FixedDimension(fpsMeterAreaHeight)
        },
        parent: {
          ref: this
        },
        htmlObject: {
          parent: {
            ref: this.settings.htmlObject
          },
          graphicParent: this
        }
      }
    );

    //raphicObjectBorders, htmlObjectBorders, graphicParentObject, htmlGraphicParentObject, htmlParentObject, canvas
    this.fpsMeterArea = new SvgRectangleArea(
      {
        location: {
          x: new FixedDimension(0),
          y: new FixedDimension(0)
        },
        size: {
          width: new PercentDimension(1),
          height: new PercentDimension(1)
        },
        parent: {
          ref: this.fpsMeterAreaRoot
        },
        htmlObject: {
          parent: {
            ref: this.fpsMeterAreaRoot.settings.htmlObject
          },
          graphicParent: this.fpsMeterAreaRoot
        }
      }
    );
    this.fpsMeterArea.setBackgroundFillColor("#ffff00");
    this.fpsMeterArea.setBackgroundStrokeColor("#000000");
    this.fpsMeterAreaRoot.addItem("Background", this.fpsMeterArea);

    this.fpsMeterLabel = new Label(
      {
        location: {
          x: new FixedDimension(0),
          y: new FixedDimension(0)
        },
        size: {
          width: new FixedDimension(this.fpsMeterArea.settings.sizeInPixels.width),
          height: new FixedDimension(this.fpsMeterArea.settings.sizeInPixels.height)
        },
        parent: {
          ref: this.fpsMeterArea
        },
        htmlObject: {
          parent: {
            ref: this.fpsMeterArea.settings.htmlObject
          },
          graphicParent: this.fpsMeterArea
        },
        title: "Fps: 0",
        fontSize: 16,
        fontFamily: "Roboto",
        color: [0, 0, 0, 1],
        isCentered: true
      }
    );
    this.fpsMeterArea.addItem("FpsMeterLabel", this.fpsMeterLabel);
    this.lastFrameTime = 0;
    this.frameCount = 0;
    this.timeSum = 0;

    this.uniforms = {
      u_color: new Float32Array([0, 1, 0, 1]),
      u_shift: new Float32Array([0.0, 0.0]),
      u_rollIndex: 0,
      u_scale: new Float32Array([1, 1]),
      u_windowSize: new Float32Array([this.settings.sizeInPixels.width, this.settings.sizeInPixels.height])
      //u_windowSize: new Float32Array([1, 1])
    };
  }

  createBorders() {
    super.createBorders();
    const fpsMeterAreaX = this.settings.sizeInPixels.width - 100;
    const fpsMeterAreaY = 2;
    this.fpsMeterAreaRoot.settings.location.x.value = fpsMeterAreaX;
    this.fpsMeterAreaRoot.settings.location.y.value =
      this.settings.htmlObject.sizeInPixels.height - fpsMeterAreaY - this.fpsMeterAreaRoot.settings.sizeInPixels.height;
    this.fpsMeterAreaRoot.setParentSize(this.settings.sizeInPixels.width, this.settings.sizeInPixels.height);
    this.fpsMeterAreaRoot.createBorders();
  }

  draw() {
    if (!this.settings.drawEnabled) {
      return;
    }
    //console.log(`online-data_canvas draw: ${this.webglItems.itemsContainer.items.length}`);
    let isSecond = false;
    if (this.lastFrameTime === 0) {
      this.lastFrameTime = performance.now();
      //console.log(`draw ${this.lastFrameTime}`);
    } else {
      const currFrameTime = performance.now() - this.lastFrameTime;
      this.timeSum += currFrameTime;
      this.frameCount++;
      isSecond = this.timeSum > 1000;
      if (isSecond) {
        this.fpsMeterLabel.setText(`Fps: ${this.frameCount}`);
        this.frameCount = 0;
        this.timeSum -= 1000;
      }
      this.lastFrameTime = performance.now();
    }

    //console.log(`frameTime: ${currFrameTime}`);
    //this.settings.gl.clearColor(1, 0.5, 0.5, 1);
    this.settings.gl.clear(this.settings.gl.COLOR_BUFFER_BIT);
    this.settings.gl.viewport(0, 0, this.settings.sizeInPixels.width, this.settings.sizeInPixels.height);
    this.webglItems.draw(this.settings.gl, this.settings.program);
  }
}
